/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { IUserSubprofileModel } from "@nf/common";
import { ROUTES } from "@nf/constants";

import LinkWithLocale from "components/LinkWithLocale";
import SubprofilesContainer from "components/Subprofiles/SubprofilesContainer";
import type { IProfileCircleProps } from "../../../components";
import { EnterPinCodeForm } from "./EnterPinCodeForm";

import styles from "./EnterPinCodeScreen.module.scss";

const ProfileCircle = dynamic<IProfileCircleProps>(() =>
  import("components/Subprofiles/ProfileCircle").then(
    (mod) => mod.ProfileCircle
  )
);

export interface IEnterPinCodeScreenProps {
  subprofile?: IUserSubprofileModel;
  pinCodeId?: string;
  close: (forceClose?: boolean) => void;
  handleSelectProfile: (subprofile?: IUserSubprofileModel) => void;
}

export const EnterPinCodeScreen = ({
  pinCodeId,
  subprofile,
  close,
  handleSelectProfile,
}: IEnterPinCodeScreenProps) => {
  const { t } = useTranslation("translations");

  const closeModal = () => {
    close();
  };

  return (
    <SubprofilesContainer close={closeModal}>
      <>
        <div className={styles.container}>
          <h2 className={styles.title}>{t("web_subprofiles_enter_pin")}</h2>
          <ProfileCircle
            subprofile={subprofile}
            editButton={false}
            size="small"
            className={styles.profileCircle}
          />
          <EnterPinCodeForm
            pinCodeId={pinCodeId}
            onSuccess={() => handleSelectProfile(subprofile)}
          />
          <LinkWithLocale href={ROUTES.SUBPROFILES_FORGOT_PIN}>
            <a>
              <p className={styles.forgotPin}>
                {t("web_subprofiles_forgot_pin")}
              </p>
            </a>
          </LinkWithLocale>
        </div>
      </>
    </SubprofilesContainer>
  );
};

export default EnterPinCodeScreen;
